import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { communication } from "../../services/communication";
import Loader from "../Loader";
import { faCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useSearchParams } from "react-router-dom";

const UpdateAnnouncement = () => {
  const router = useNavigate();
  const [searchParams] = useSearchParams();
  const [loader, setLoader] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  const state = watch("state");

  // const onSubmit = async (data) => {
  //   console.log("data : ", data)
  //   try {
  //     setLoader(true);
  //     const responseFromServer = await communication.createAnnouncement(data);
  //     if (responseFromServer?.data?.status === "SUCCESS") {
  //       setLoader(false);
  //       // router("/main-panel/complaint");
  //       Swal.fire({ text: responseFromServer?.data?.message, icon: "success" });
  //     } else if (responseFromServer?.data?.status === "JWT_INVALID") {
  //       setLoader(false);
  //       Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
  //       router("/login");
  //     } else {
  //       setLoader(false);
  //       Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
  //     }
  //   } catch (error) {
  //     setLoader(false);
  //     Swal.fire({ text: error?.response?.data?.message || error.message, icon: "warning" });
  //   }
  // };


  const onSubmit = async (data) => {
    console.log("data : ", data);
    try {
      const payload = {
        title: data?.title,
        description: data?.description,
        _id: searchParams.get("id")
      }
      setLoader(true);
      const responseFromServer = await communication.updateAnnouncement(payload); // Directly sending `data` as JSON
      if (responseFromServer?.data?.status === "SUCCESS") {
        setLoader(false);
        Swal.fire({ text: responseFromServer?.data?.message, icon: "success" });
        router("/main-panel/complaint")
      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        setLoader(false);
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        router("/login");
      } else {
        setLoader(false);
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
      }
    } catch (error) {
      setLoader(false);
      Swal.fire({ text: error?.response?.data?.message || error.message, icon: "warning" });
    }
  };

  async function getAnnouncementById() {
    try {
      setLoader(true);
      const responseFromServer = await communication.getAnnouncementById(searchParams.get("id"));
      if (responseFromServer?.data?.status === "SUCCESS") {

        console.log(" responseFromServer?.data?.data?.announcement?.title :     ", responseFromServer?.data?.announcement?.title)
        setValue("title", responseFromServer?.data?.announcement?.title);
        setValue("description", responseFromServer?.data?.announcement?.description);
        setValue("createdBy", responseFromServer?.data?.announcement?.createdBy);
        setValue("position", responseFromServer?.data?.announcement?.position);
        // setValue("createdAt", responseFromServer?.data?.announcement?.createdAt);
        // setValue("updatedAt", responseFromServer?.data?.announcement?.updatedAt);

      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        router("/login");
      } else {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
      }
    } catch (error) {
      Swal.fire({ text: error?.response?.data?.message || error.message, icon: "warning" });
    } finally {
      setLoader(false);
    }
  }

  useEffect(() => {
    getAnnouncementById();
  }, []);
  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className="add_update_form_wrapper">
          <div className="add_update_form_main position-relative">
            <div
              title="Go back"
              onClick={() => router("/main-panel/complaint")}
              className="User_back_icon"
            >
              <FontAwesomeIcon icon={faCircleLeft} />
            </div>

            <div className="add_update_form_section">
              <div className="add_update_heading">
                <h4>Update Announcement</h4>
              </div>

              <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                <div className="input_col">
                  <div className="label_div">
                    <label>Title</label>
                  </div>
                  <div className="input_div">
                    <input
                      {...register("title", {
                        required: "title is required",
                        pattern: {
                          value: /^[A-Za-z\s]+$/,
                          message: "title should contain only letters",
                        },
                      })}
                      placeholder={"Enter title"}
                      type="text"
                      className="form-control input login_input"
                    />
                    <div className="error-message">
                      {errors?.title && (
                        <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                          {errors?.title.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="input_main_wrapper" style={{ justifyContent: "center" }}>
                <div className="input_col">
                  <div className="label_div">
                    <label>Description</label>
                  </div>
                  <div className="input_div">
                    <textarea
                      {...register("description", {
                        required: "Description is required",
                        // pattern: {
                        //   // value: /^[A-Za-z\s]+$/,
                        //   message: "Description should contain only letters",
                        // },
                      })}
                      placeholder={"Enter Description"}
                      row={5}
                      className="form-control input login_input"
                    />
                    <div className="error-message">
                      {errors?.description && (
                        <p className="text-danger text-start" style={{ fontSize: "0.8rem" }}>
                          {errors?.description.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>





              {/* submit and cancel button for add user page*/}
              <div className="button_wrapper">
                <div className="button_col">
                  <button
                    type="submit"
                    onClick={handleSubmit(onSubmit)}
                    className="btn btn-primary submit_button"
                  >
                    Submit
                  </button>
                </div>
                <div className="button_col">
                  <button
                    onClick={() => router("/main-panel/complaint")}
                    className="btn btn-primary cancel_button"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateAnnouncement;
